export default {
  'menuDecoratePreview.title': '平板点餐Pro版效果预览',
  'menuDecoratePreview.preparingData': '准备数据中...',
  'menuDecoratePreview.errors.load_qr_link_failed': '加载扫码点餐码失败',
  'menuDecoratePreview.errors.no_qr_link': '暂无扫码点餐码。 请前往<a>智能点餐 > 扫码点餐 > 二维码下载</a>生成',
};
